import { IItemGroupSelectBehavior, IItemGroupSelectBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanItemsSelectable } from "../../../beans/objects";

export class ItemGroupSelectBehaviorTranslator {
  from(bean: IObjectBeanItemsSelectable): IItemGroupSelectBehavior {
    return {
      groupName: bean["@group"],
    };
  }

  to(object: IItemGroupSelectBehaviorSpecifiable) {
    return {
      group: object.itemGroupSelectBehavior.groupName,
    };
  }
}
